import React, { memo } from 'react';
import { pdfStyles } from '../../pdfStyles';
import { Page } from '@react-pdf/renderer';
import { Footer, Header, TableOfContants } from '../../comps';
import { isEqual } from 'lodash';
import { Toc } from '../../types';
import { ColorSet } from 'src/redux/reducers/theme';

interface AssessmentTocProps {
  contents: Toc[];
  colors: ColorSet;
  logoSrc?: string;
  primaryColor?: string | null;
  secondaryColor?: string | null;
}

export const AssessmentToc: React.FC<AssessmentTocProps> = memo(
  ({ contents, colors, logoSrc, primaryColor }) => {
    return (
      <Page size={'A4'} style={pdfStyles.page} id="toc">
        <Header colors={colors} logoSrc={logoSrc} />
        <TableOfContants contents={contents} colors={colors} primaryColor={primaryColor} />
        <Footer colors={colors} />
      </Page>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
